<template>
  <div style="padding: 20px;">
    <h2>Personnaliser Mes Meilleurs Menus : 8 choses à savoir</h2>
    <p>Je peux personnaliser Mes Meilleurs Menus notamment en fonction :</p>
    <ol>
      <li>
        De la fréquence de consommation de viande et/ou de poisson par semaine que je choisis dans Mes préférences.
      </li>
      <li>
        Si je le souhaite dans Mes préférences, je peux choisir les options végétariennes, sans gluten, à faible indice glycémique :
        <ul>
          <li><strong>Option végétarienne</strong> : pour une alimentation saine sans viande ni poisson mais équilibrée en protéines et autres nutriments avec notamment la consommation d’œufs et de légumineuses.</li>
          <li><strong>Option sans gluten</strong> : avec des recettes à base d’ingrédients ne contenant pas de gluten</li>
          <li><strong>Option à faible indice glycémique</strong> : assure que l'ensemble des repas a un faible indice glycémique. À noter que si vous avez une pathologie telle que le diabète de type 2 il est important de suivre les recommandations de votre médecin et/ou de votre diététicienne et de vous renseigner sur les aliments que vous pouvez consommer.</li>
        </ul>
      </li>
      <li>
        De mon temps disponible pour cuisiner, en complétant le tableau de Mes préférences. Je peux soit indiquer la même durée maximum pour tous les repas de la semaine ou indiquer une durée maximum pour chacun des repas.
        <br>À noter que le temps de préparation englobe les temps de cuissons qui peuvent de temps en temps être longs mais ne demandent donc pas forcément beaucoup de travail. Le temps indiqué est celui du plat principal, sachant que généralement l’entrée peut être préparée durant les temps de cuisson.
      </li>
      <li>
        De la taille de mon foyer, pour de 1 à 6 personnes, y compris les enfants. Pour ajouter une personne en plus, il suffit de se rendre dans « mes préférences ».
      </li>
      <li>
        Des goûts et des allergies alimentaires de mon foyer, en les précisant dans Mes préférences. À noter que l’objectif est de découvrir et de privilégier les légumes de saison. Donc en dehors des allergies, nous vous invitons à n’enlever que les ingrédients que vous ne pouvez vraiment pas consommer.
      </li>
      <li>
        De mon niveau d’activité physique en modifiant les paramètres de Mes préférences en précisant mon temps d'activité physique moyenne par jour :
        <ul>
          <li>De faible intensité : temps passé debout, d’attente passive, à cuisiner ou un travail statique</li>
          <li>D’intensité modérée : travail de production, ménage simple, menuiserie, yoga, marche</li>
          <li>De forte intensité : travaux du bâtiment, bêchage, ménage intensif, sport en compétition, course</li>
        </ul>
      </li>
      <li>
        De mon souhait – ou non – de perdre du poids (environ 1kg par mois voire davantage), à choisir dans Mes préférences. Si je suis déjà à mon poids de forme, je garderai mon poids de forme en suivant « Mes Meilleurs Menus ».
      </li>
      <li>
        De mon budget, en cochant « menus bon marché » dans Mes préférences. Si je choisis cette préférence, je recevrai des propositions de menus à base de légumes de saison, sans produits de la mer onéreux (ex. saumon ou crevettes) et privilégiant les viandes blanches, à la fois bonnes pour la santé et économiques. Nous vous conseillons de vous procurer vos légumes dans des fermes proches de chez vous.
      </li>
    </ol>

    <p>Je peux modifier mes propositions de menus en allant dans « mes menus » pour optimiser encore plus Mes Meilleurs Menus.</p>

    <p>
      Une fois que Mes Meilleurs Menus me proposent mes menus pour la semaine, je peux encore les changer en remplaçant un menu par un autre grâce à un outil de remplacement. J’ai alors le choix entre :
    </p>
    <ol>
      <li>Un nouveau menu choisi parmi les menus qui répondent à mes souhaits de personnalisation</li>
      <li>Un de mes plats préférés que j’ai sélectionnés</li>
      <li>Un plat contenant un ingrédient de mon choix (reste au frigo, légume du jardin ou de la ferme, aliment acheté en promotion, etc…)</li>
    </ol>

    <h2>Personnaliser ma liste de courses : 2 choses à savoir</h2>
    <p>Dans « Mes courses », je peux personnaliser ma liste de courses en :</p>
    <ol>
      <li>
        Décochant certains des menus de la semaine (parce que je vais au restaurant ou j’ai prévu de manger autre chose). La liste de courses se met alors automatiquement à jour en retirant les ingrédients des repas que j’ai décochés.
      </li>
      <li>
        Décochant certains ingrédients de la liste de courses que j’ai déjà à la maison. Je peux ensuite cliquer sur un bouton de mise à jour et obtenir ma liste de courses avec les seuls ingrédients et les bonnes quantités dont j’ai vraiment besoin.
      </li>
    </ol>

    <p>Par souci d’économies et de protection de l’environnement, Mes Meilleurs Menus me conseillent de privilégier les légumes et fruits de saison récoltés et achetés près de chez moi.</p>
  </div>
</template>

<script>
export default {
  name: "ModeDEmploi",
};
</script>

<style scoped>
/* Tu peux ajouter ici des styles spécifiques à la page */
</style>
